/**
 * Represents the status of a data synchronization session.
 * Matches backend DataSyncStatus enum
 */
export enum ImportStatus {
  /**
  * Synchronization is not started (no jobs published or started).
  */
  NotStarted = 0, 
   /**
   * 
   * Synchronization is pending (jobs not yet published or started).
   */
  Pending = 1,

  /**
   * Synchronization is in progress (jobs are being processed).
   */
  Importing = 2,

  /**
   * Synchronization completed successfully.
   */
  Completed = 3,
}
